<template>
  <div v-if="!smallScreen" class="scrollable-modal two-column-scrollable-modal">
    <v-row class="top-nav align-center" v-if="showTitle">
      <slot name="title"> </slot>
    </v-row>
    <v-row class="mx-0" style="max-width: 100%; width: 100%">
      <v-col :cols="leftWidth" class="pl-3 pr-3 fill-height left-container">
        <perfect-scrollbar
          class="left ps--scroll-y-always pr-4"
          style="max-height: 100%"
          :options="{ suppressScrollX: true, wheelPropagation: false }"
        >
          <slot name="left"> </slot>
        </perfect-scrollbar>
      </v-col>
      <v-col
        :cols="rightWidth"
        class="pl-3 pr-3 flex-fill fill-height right-container"
      >
        <perfect-scrollbar
          class="content ps--scroll-y-always pr-4"
          style="max-height: 100%"
          :options="{ suppressScrollX: true, wheelPropagation: false }"
        >
          <slot name="right"> </slot>
        </perfect-scrollbar>
        <v-row class="action-bar" v-if="showScrollableBar">
          <v-col cols="12">
            <slot name="action-bar"> </slot>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
  <simple-scrollable-modal
    v-else
    :show-scrollable-bar="showScrollableBar"
    :show-title="showTitle"
  >
    <template #title>
      <slot name="title"> </slot>
    </template>
    <template #content>
      <v-row>
        <v-col class="pt-0" cols="12">
          <slot name="left"> </slot>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pb-0" cols="12">
          <slot name="right"> </slot>
        </v-col>
      </v-row>
    </template>
    <template #action-bar>
      <slot name="action-bar"> </slot>
    </template>
  </simple-scrollable-modal>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { vueData } from '../../../VueData';
  import SimpleScrollableModal from './SimpleScrollableModal.vue';
  @Component({
    components: { SimpleScrollableModal },
  })
  export default class TwoColumnScrollableModal extends Vue {
    @Prop({ default: '6' }) leftWidth: string;
    @Prop({ default: '6' }) rightWidth: string;
    @Prop({ default: true }) showScrollableBar;
    @Prop({ default: true }) showTitle;
    windowWidth = 0;

    async created() {
      this.windowWidth = vueData.windowWidth;
    }

    mounted() {
      window.addEventListener('resize', this.onWindowResize.bind(this));
    }

    beforeDestroy() {
      window.removeEventListener('resize', this.onWindowResize.bind(this));
    }

    onWindowResize() {
      Vue.nextTick(() => {
        this.windowWidth = vueData.windowWidth;
      });
    }

    get smallScreen() {
      return this.windowWidth < 900;
    }
  }
</script>
